import { render, staticRenderFns } from "./SelfBurden.vue?vue&type=template&id=5557b3d1&"
import script from "./SelfBurden.vue?vue&type=script&lang=ts&"
export * from "./SelfBurden.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports